import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { showModal } from '../../../actions';
import { clearFacePerson } from '../../../actions/Files';
import {
  hideFace,
  unhideFace,
} from '../../../actions/People';

import Avatar from '../../Avatar';

import { isShare } from '../../../helpers/App';
import { userCanEditPeople } from '../../../helpers/Files';
import { eventDispatch } from '../../../helpers/Events';

const FileViewFaceTip = ({
  dispatch,
  file,
  highlight,
  readOnly,
}) => {
  const intl = useIntl();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const { person } = highlight;

  const toggleDropdown = () => setDropdownOpen(prevState => !prevState);

  useEffect(() => {
    setDropdownOpen(false);
  }, [person]);

  const openChangePersonModal = () => {
    dispatch(showModal('ChangePersonModal', {
      className: 'modal-change-person',
      face: highlight,
    }));
  };

  const handleClearPerson = () => {
    eventDispatch('faceUpdated', { ...highlight, person: { ...highlight.person, name: null } });
    clearFacePerson(highlight.uuid);
  };

  const handleSwitchFaceVibility = () => {
    if (highlight.hidden) {
      unhideFace(highlight.uuid);
    } else {
      hideFace(highlight.uuid);
    }
    eventDispatch('faceUpdated', { ...highlight, hidden: !highlight.hidden });
  };

  const isEditPeopleAllowed = userCanEditPeople(file) && !readOnly;

  if (!person) {
    return null;
  }

  return (
    <div className="face-tip">
      <div className="face-tip-content">
        <Avatar user={{ avatar_url: person.image_path, name: person.name }} size={30} />
        {person.name || intl.formatMessage({ defaultMessage: 'Unnamed person' })}
        {!isShare() && (
          <>
            <span className="face-tip-separator" />
            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
              <DropdownToggle nav>
                <i className="far fa-chevron-down" />
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  tag={Link}
                  to={`/files?people=${person.uuid}`}
                  target="_blank"
                >
                  <i className="far far fa-images" />
                  {intl.formatMessage({ defaultMessage: 'View all images' })}
                </DropdownItem>
                {isEditPeopleAllowed && (
                  <>
                    <DropdownItem
                      onClick={openChangePersonModal}
                    >
                      <i className="far fa-user-viewfinder fa-fw" />
                      {person.name ? (
                        intl.formatMessage({ defaultMessage: 'Change person' })
                      ) : (
                        intl.formatMessage({ defaultMessage: 'Select person' })
                      )}
                    </DropdownItem>
                    <DropdownItem
                      onClick={handleSwitchFaceVibility}
                    >
                      {highlight.hidden ? (
                        <>
                          <i className="far fa-eye" />
                          {intl.formatMessage({ defaultMessage: 'Unhide face' })}
                        </>
                      ) : (
                        <>
                          <i className="far fa-eye-slash" />
                          {intl.formatMessage({ defaultMessage: 'Hide face' })}
                        </>
                      )}
                    </DropdownItem>
                    {person.name && (
                      <DropdownItem
                        className="error"
                        onClick={handleClearPerson}
                      >
                        <i className="far fa-circle-half-stroke fa-rotate-by" style={{ '--fa-rotate-angle': '45deg' }} />
                        {intl.formatMessage({ defaultMessage: 'Clear' })}
                      </DropdownItem>
                    )}
                  </>
                )}
              </DropdownMenu>
            </Dropdown>
          </>
        )}
      </div>
    </div>
  );
};

FileViewFaceTip.propTypes = {
  dispatch: PropTypes.func.isRequired,
  file: PropTypes.object.isRequired,
  highlight: PropTypes.object,
  readOnly: PropTypes.bool,
};

FileViewFaceTip.defaultProps = {
  highlight: null,
  readOnly: null,
};

export default connect()(FileViewFaceTip);
